__turbopack_context__.v({
  "cardCategory": "ImageCard-module__9y1FQG__cardCategory",
  "clickableArea": "ImageCard-module__9y1FQG__clickableArea",
  "contentWrapper": "ImageCard-module__9y1FQG__contentWrapper",
  "excerpt": "ImageCard-module__9y1FQG__excerpt",
  "headingWrap": "ImageCard-module__9y1FQG__headingWrap",
  "image": "ImageCard-module__9y1FQG__image",
  "inspirationCard": "ImageCard-module__9y1FQG__inspirationCard",
  "inspirationContent": "ImageCard-module__9y1FQG__inspirationContent",
  "inspirationHeadingWrap": "ImageCard-module__9y1FQG__inspirationHeadingWrap",
  "subheader": "ImageCard-module__9y1FQG__subheader",
  "title": "ImageCard-module__9y1FQG__title",
});
